export default __webpack_public_path__ + "static/media/016-balloons.fd420106.svg";